// extracted by mini-css-extract-plugin
export var details = "_l5-0";
export var inspectorPopover = "_l5-1";